import { render, staticRenderFns } from "./SlimHome.vue?vue&type=template&id=7390ae9b&scoped=true&"
import script from "./SlimHome.vue?vue&type=script&lang=js&"
export * from "./SlimHome.vue?vue&type=script&lang=js&"
import style0 from "./SlimHome.vue?vue&type=style&index=0&id=7390ae9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7390ae9b",
  null
  
)

export default component.exports